import { IBaseUseQueryProps } from '../../../interfaces/baseUseQueryProps';
import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { IErrorResponse } from '../../../interfaces/errorResponse';
import { parseAxiosError } from '../../../services/axios';
import { ProjectOpportunityService } from '../../../services/project-opportunity';
import {
  IProjectPositionSearchRequest,
  IProjectPositionSearchResponse
} from '../../../interfaces/projectPostitionSearch';
import { IListResponse } from '../../../interfaces/listResponse';
import { useNotification } from '../../../+state/useNotification';


export const GET_ALL_POSITIONS_QUERY_KEY = 'get-all-positions';

interface IProps extends IBaseUseQueryProps<IListResponse<IProjectPositionSearchResponse>> {
  search: IProjectPositionSearchRequest
}

export const useGetAllPositions = ({ search, ...props }: IProps) => {
  const { openErrorToast } = useNotification();
  return useQuery({
    queryKey: [GET_ALL_POSITIONS_QUERY_KEY, search],
    queryFn: () => ProjectOpportunityService.getAllPositions(search),
    refetchOnWindowFocus: false,
    keepPreviousData: true,
    onError: (err: AxiosError<IErrorResponse>) => {
      openErrorToast(parseAxiosError(err));
      props?.onError?.(err);
    },
    ...props
  });
};